import { render, staticRenderFns } from "./distribution.vue?vue&type=template&id=e285c1fc&scoped=true&"
import script from "./distribution.vue?vue&type=script&lang=js&"
export * from "./distribution.vue?vue&type=script&lang=js&"
import style0 from "./distribution.vue?vue&type=style&index=0&id=e285c1fc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e285c1fc",
  null
  
)

export default component.exports